import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class CustomizedYAxisTick extends PureComponent {
  render() {
    const { x, y, payload } = this.props;
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={-10}
          y={0}
          dy={1}
          textAnchor="middle"
          fill="#565a5c"
          fontSize="12px"
          fontFamily="felix-medium"
        >
          ${payload.value}
        </text>
      </g>
    );
  }
}

CustomizedYAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.object
};

CustomizedYAxisTick.defaultProps = {
  x: 0,
  y: 0,
  payload: {}
};

export default CustomizedYAxisTick;
